<template>
  <BreadCrumb PageTitle="Modifier bon d'envoie" />
  <EditInvoice  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EditInvoice from "@/components/Invoices/EditInvoice.vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditInvoicePage",
  components: {
    BreadCrumb,
    EditInvoice,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id; 
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    let refNote = route.params.refNote; 
    if (Array.isArray(refNote)) {
      refNote = refNote[0] ?? "";
    }


    return { id , refNote};
}
});
</script>